import React from 'react';
import HistoryHeader from './history-header';
import SelectHistory from './select-history';
import HistoryResult from './history-result';
import HistoryFooter from './history-footer';

export default class CalcHistory extends React.Component {

    constructor(props) {
        super(props);

        const saved_calc_histories = localStorage.getItem('calc_histories');
        const calc_histories = saved_calc_histories ? JSON.parse(saved_calc_histories) : [];

        this.state = {
            active_page: 0,
            is_one_serving: true,
            calc_histories: calc_histories,
            selected_history: null,
            is_toast_show: false,
            toast_text: '',
        }
    }

    handleActivePageChange = async (new_value) => {
        this.setState({
            active_page: new_value,
        });
    }

    handleSelectHistoryChange = (key) => {
        const history = this.state.calc_histories.find((val) => val.key === key);
        console.log(history);
        if (history) {
            this.setState({
                selected_history: history,
            });
        }

    }

    handleOneServingChange = (new_value) => {
        this.setState({
            is_one_serving: new_value,
        });
    }

    handleDeleteHistory = (key) => {
        const after_histories = this.state.calc_histories.filter((val) => val.key !== key);
        try {
            localStorage.setItem('calc_histories', JSON.stringify(after_histories));
            this.setState({
                calc_histories: after_histories,
                selected_history: null,
                active_page: 0,
                is_toast_show: true,
                toast_text: '削除しました。',
            });
            setTimeout(() => {
                this.setState({
                    is_toast_show: false,
                });
            }, 2000);
        } catch (e) {
            alert('削除できませんでした。');
        }
    }

    handleAllDeleteHistory = () => {
        try {
            localStorage.removeItem('calc_histories');
            this.setState({
                calc_histories: [],
                selected_history: null,
                active_page: 0,
                is_toast_show: true,
                toast_text: '削除しました。',
            });
            setTimeout(() => {
                this.setState({
                    is_toast_show: false,
                });
            }, 2000);
        } catch (e) {
            alert('削除できませんでした。');
        }
    }

    handleToastShow = (text_value) => {
        this.setState({
            is_toast_show: true,
            toast_text: text_value,
        });

        setTimeout(() => {
            this.setState({
                is_toast_show: false,
            });
        }, 2000);
    }

    componentDidMount() {
        // 初期処理
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <div className="main-contents">
                    <HistoryHeader active_page={this.state.active_page}/>
                    {
                        this.state.active_page === 0 &&
                        <SelectHistory
                            calc_histories={this.state.calc_histories}
                            selected_history={this.state.selected_history}
                            onSelectHistoryChange={this.handleSelectHistoryChange}
                            onDeleteHistory={this.handleDeleteHistory}
                            onAllDeleteHistory={this.handleAllDeleteHistory}
                        />
                    }
                    {
                        this.state.active_page === 1 &&
                        <HistoryResult
                            is_one_serving={this.state.is_one_serving}
                            selected_history={this.state.selected_history}
                            onOneServingChange={this.handleOneServingChange}
                            onDeleteHistory={this.handleDeleteHistory}
                            onToastShow={this.handleToastShow}
                        />
                    }
                    <HistoryFooter next_disabled={this.state.active_page === 0 && !this.state.selected_history} active_page={this.state.active_page} onActivePageChange={this.handleActivePageChange}/>
                    <div className={`toast ${this.state.is_toast_show ? 'visible' : ''}`}>{this.state.toast_text}</div>
                </div>
            </React.Fragment>
        );
    }
}